import * as React from "react";
import "./ConfirmationDialogue.scss";
import { Button, Modal } from "@forge/common";

interface IProps {
  title: string;
  message: string;
  /**
   * If empty string is passed, the primary button will not be rendered.
   */
  primaryButtonText?: string;
  /**
   * callback when the primary button is clicked.
   */
  onPrimaryButtonClick?: () => void;
  /**
   * If empty string is passed, the secondary button will not be rendered.
   */
  secondaryButtonText?: string;
  /**
   * callback when the secondary button is clicked.
   */
  onSecondaryButtonClick?: () => void;
  /**
   * Callback when the modal is closed.
   */
  onModalClose?: () => void;
}

ConfirmationDialog.defaultProps = {
  secondaryButtonText: "",
  primaryButtonText: "",
};

/**
 * CustomDialog component.
 *
 * @param props - The component props.
 * @returns The rendered CustomDialog component.
 */
function ConfirmationDialog(props: IProps) {
  return (
    <Modal
      onBackdropClick={function noRefCheck() {}}
      onModalClose={() => props.onModalClose && props.onModalClose()}
      footerLeft={undefined}
      footerRight={undefined}
      title={props.title}
      className="confirmation-dialog"
      children={
        <div className="modal-content">
          <div className="modal-message">{props.message}</div>

          <div className="modal-action m-t10">
            {props.secondaryButtonText !== "" && (
              <Button
                onClick={() =>
                  props.onSecondaryButtonClick && props.onSecondaryButtonClick()
                }
                size="regular"
                variant="secondary"
              >
                {props.secondaryButtonText}
              </Button>
            )}
            {props.primaryButtonText !== "" && (
              <Button
                onClick={() =>
                  props.onPrimaryButtonClick && props.onPrimaryButtonClick()
                }
                size="regular"
                variant="primary"
              >
                {props.primaryButtonText}
              </Button>
            )}
          </div>
        </div>
      }
    />
  );
}

export default ConfirmationDialog;
